export default "__VITE_ASSET__ByNfpYf9__"